import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { take, map, identity, filter } from 'ramda';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';
import { formatMedDate } from 'routes/Documents/routes/Medication/formatters';

import { path } from 'routes/Documents/routes/Medication';
import icon from '../assets/medication.svg';

const predicate = d => d.documentType === 'medication' && d.drug && d.drug.name;

const View = ({ data, localeMessage, count }) => {
  return (
    <Grid fluid>
      {map(d => (
        <TileRow key={d.documentId} title={formatMedDate(d, localeMessage, identity)}>
          <p className="bold">{`${d.drug.name} (${d.drug.company})`}</p>
        </TileRow>
      ))(take(3, filter(predicate, data)))}
      <p style={{ position: 'absolute', bottom: '1.7rem', left: '2rem' }}>
        {count.medication > 3 &&
          localeMessage('medication.summary.hiddenMedText', {
            medicationCount: count.medication - 3 > 0 ? count.medication - 3 : 0,
          })}
        {count.vitamin > 0 &&
          localeMessage('medication.summary.hiddenVitText', {
            medicationCount: count.medication - 3 > 0 ? count.medication - 3 : 0,
            vitaminCount: count.vitamin ? count.vitamin : 0,
          })}
      </p>
    </Grid>
  );
};

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
  count: PropTypes.object,
};

export default createSummaryTile(View, {
  module: ['medication', 'vitamin'],
  localeId: 'medication.title',
  routeTo: path,
  icon,
});
